import { publicUrlFor } from "../../globals/constants";

function InnerPageBanner({ _data }) {
  return (
    <>
      <div
        className="wt-bnr-inr overlay-wraper bg-center"
        style={{ backgroundImage: `url(${publicUrlFor(_data.imgUrl)})` }}
      >
        <div className="overlay-main site-bg-white opacity-01" />
        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-outer">
              <div className="banner-title-name">
                <h2 className="wt-title">{_data.title}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InnerPageBanner;
